<script setup>
import {onMounted, ref, watch} from "vue";

const props = defineProps({
    automation: {
        type: Object,
        required: true,
    }
})

const updateDatetime = (newDate) => {
    props.automation.activate_at = newDate;
}

const scheduleType = ref('')

const scheduleTypes = [
    {
        label: _mft('communication:automation.schedule.inactive.title'),
        byline: _mft('communication:automation.schedule.inactive.description'),
        value: 'draft',
    },
    {
        label: _mft('communication:automation.schedule.active.title'),
        byline: _mft('communication:automation.schedule.active.description'),
        value: 'send_immediately',
    },
    {
        label: _mft('communication:automation.schedule.automationSchedule.title'),
        byline: _mft('communication:automation.schedule.automationSchedule.description'),
        value: 'schedule',
    },
];

const setScheduleType = () => {
    if (props.automation.is_active) {
        scheduleType.value = 'send_immediately';
        return;
    }
    if (props.automation.activate_at) {
        scheduleType.value = 'schedule'
    } else {
        scheduleType.value = 'draft'
    }
}

const onScheduleTypeSelected = (type) => {
    scheduleType.value = type
    props.automation.activate_at = null;
}

watch(() => scheduleType.value, (type) => {
    if (type === 'schedule') {
        props.automation.schedule_type = 'schedule';
    } else if (type === 'send_immediately') {
        props.automation.schedule_type = 'send_immediately';
    } else {
        props.automation.schedule_type = null;
    }
}, {immediate: true})

onMounted(() => {
    setScheduleType()
})

</script>

<template>
    <div v-if="automation">
        <div class="grid md:grid-cols-2 gap-8">
            <div>
                <input-radios-v2
                    :content="scheduleType"
                    :options="scheduleTypes"
                    @update:content="onScheduleTypeSelected"
                    :label="_mft('communication:automation.schedule.type')"
                    name="scheduleType"
                />
            </div>

            <div>
                <div
                    v-if="scheduleType === 'draft'"
                >
                    <card-sub>
                        <p class="text-gray-500 text-center max-w-72 mx-auto">
                            <span v-if="automation.is_active">
                                {{ _mft('communication:automation.schedule.disabledWhenSaved') }}
                            </span>
                            <span v-else>
                                {{ _mft('communication:automation.schedule.draftWillNotSend') }}
                            </span>
                        </p>
                    </card-sub>
                </div>
                <div
                    v-if="scheduleType === 'send_immediately'"
                >
                    <card-sub>
                        <p class="text-gray-500 text-center max-w-72 mx-auto">
                            <span v-if="automation.is_active">
                                <strong class="block mb-3">{{ _mft('communication:automation.schedule.activeSince') }} {{ automation.activate_at_display }}</strong>
                                <span>{{ _mft('communication:automation.schedule.active') }}</span>
                            </span>
                            <span v-else>
                                {{ _mft('communication:automation.schedule.willActiveWhenSaved') }}
                            </span>
                        </p>
                    </card-sub>
                </div>

                <div
                    v-if="scheduleType === 'schedule'"
                >
                    <div class="w-full max-w-md">
                        <input-datepicker
                            name="date"
                            :date="automation.activate_at"
                            :rangeMode="false"
                            :showTime="true"
                            :min-time="new Date(new Date().setHours(new Date().getHours() - 2))"
                            :min-date="new Date(new Date().setHours(new Date().getHours() - 2))"
                            @update:date="updateDatetime"
                            class="!mt-1 w-full mb-4 !block"
                        />
                        <div class="flex justify-end">
                            <button-warning
                                v-if="automation.activate_at"
                                @click="automation.activate_at = null"
                            >
                                {{ _mft('communication:automation.scheduled.clear') }}
                            </button-warning>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
